import { useState } from "react";
import axiosClient from "../../api/axiosClient";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./Auth.css";

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* =====================================================
     HANDLE LOGIN
  ===================================================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.email || !form.password) {
      toast.error("Email and password are required");
      return;
    }

    try {
      setLoading(true);

      const res = await axiosClient.post("/auth/login", form);

      if (!res.data?.token || !res.data?.user) {
        throw new Error("Invalid response from server");
      }

      // ✅ CENTRALIZED AUTH LOGIN
      login(res.data.user, res.data.token);

      toast.success("Login successful!");

      // ✅ ROLE BASED REDIRECT
      if (res.data.user.role === "admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/");
      }

    } catch (err) {
      console.error("Login error:", err);
      toast.error(
        err.response?.data?.message || "Invalid email or password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {loading && (
        <LoadingSpinner overlay message="Logging in" sub="Please wait a moment…" />
      )}
      <div className="auth-container">
        <div className="auth-header">
          <h2>Welcome <span>Back</span></h2>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            className="auth-input"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            className="auth-input"
            value={form.password}
            onChange={handleChange}
            required
          />

          <button className="auth-submit" disabled={loading}>
            Login
          </button>

          <p
            className="fp-link"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </p>
        </form>

        <p className="auth-back" onClick={() => navigate("/signup")}>
          ← Create new account
        </p>
      </div>
    </div>
  );
}

export default Login;
